var _path, _path2, _path3, _path4;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCard = function SvgCard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 52,
    viewBox: "0 0 70 52",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.166504 8.58317C0.166504 4.21092 3.71092 0.666504 8.08317 0.666504H61.9165C66.2888 0.666504 69.8332 4.21092 69.8332 8.58317V43.4165C69.8332 47.7888 66.2888 51.3332 61.9165 51.3332H8.08317C3.71091 51.3332 0.166504 47.7888 0.166504 43.4165V8.58317ZM8.08317 6.99984C7.20872 6.99984 6.49984 7.70872 6.49984 8.58317V43.4165C6.49984 44.291 7.20872 44.9998 8.08317 44.9998H61.9165C62.791 44.9998 63.4998 44.291 63.4998 43.4165V8.58317C63.4998 7.70872 62.791 6.99984 61.9165 6.99984H8.08317Z",
    fill: "#8290A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 13.333H66.6663V22.833H3.33301V13.333Z",
    fill: "#8290A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 37.0832C11.25 35.3343 12.6678 33.9165 14.4167 33.9165H17.5833C19.3322 33.9165 20.75 35.3343 20.75 37.0832C20.75 38.8321 19.3322 40.2498 17.5833 40.2498H14.4167C12.6678 40.2498 11.25 38.8321 11.25 37.0832Z",
    fill: "#8290A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5 37.0832C25.5 35.3343 26.9178 33.9165 28.6667 33.9165H38.1667C39.9156 33.9165 41.3333 35.3343 41.3333 37.0832C41.3333 38.8321 39.9156 40.2498 38.1667 40.2498H28.6667C26.9178 40.2498 25.5 38.8321 25.5 37.0832Z",
    fill: "#8290A2"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/card.a10fad90.svg";
export { ForwardRef as ReactComponent };